import CommentRow from './comment-row.comp'

export { CommentRow }
